export default "__VITE_ASSET__BrBsxVMQ__"